export default __webpack_public_path__ + "static/media/community.bc0bcb1f.png";